import { useQuery } from '@tanstack/react-query';

import type { AdminTenantListResponse } from '../api/client';
import { useAdminAuth } from '../auth/AuthProvider';
import { TenantTable } from '../components/TenantTable';

export function TenantsPage() {
  const { fetcher } = useAdminAuth();
  const { data, isLoading, error } = useQuery({
    queryKey: ['admin', 'tenants'],
    queryFn: () =>
      fetcher<AdminTenantListResponse>('/admin/api/tenants?page_size=200'),
  });

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold">Tenants</h1>
        {data ? (
          <span className="text-sm text-slate-500">{data.total} total</span>
        ) : null}
      </div>
      {isLoading ? <div>Loading…</div> : null}
      {error ? (
        <div className="card text-red-600">
          {(error as Error).message}
        </div>
      ) : null}
      {data ? <TenantTable tenants={data.tenants} /> : null}
    </div>
  );
}
